import styles from "./BanquetRoomPicker.module.css";
import { useSiteInfo } from "../context/SiteContext";
import React, { useState } from "react";

function BanquetRoomPicker({ location_id, selectedRoom, onRoomChange }) {
  //const { banRooms } = useSiteInfo();
  //const [theRoom, setTheRoom] = useState(selectedRoom);
  const banRooms = JSON.parse(sessionStorage.getItem("banRooms"));
  const filteredBanquetRooms = banRooms.filter(
    (room) => room.LocationID == location_id
  );

  return (
    <select
      id=""
      name="banquetRoom"
      className={styles.select}
      onChange={
        onRoomChange
          ? onRoomChange
          : (e) => {
              selectedRoom = e.target.value;
            }
      }
      value={selectedRoom}
    >
      <option value={1}>Select Banquet Room</option>
      {filteredBanquetRooms.map((banRoom) => {
        return (
          <option value={banRoom.idBanquetRooms} key={banRoom.idBanquetRooms}>
            {banRoom.RoomName}
          </option>
        );
      })}
    </select>
  );
}

export default BanquetRoomPicker;
